import { DetailsList, DetailsListLayoutMode, IColumn, SelectionMode, Text } from '@fluentui/react'
import { QuarterSubscriber } from '../../api/models'
import { MUTED_TEXT } from './krStyles'

type SubscribersTableProps = {
  subscribers: QuarterSubscriber[]
  ariaLabel: string
  emptyMessage: string
}

const PLACEHOLDER = '—'

const orPlaceholder = (value: string | null): string => value?.trim() || PLACEHOLDER

const columns: IColumn[] = [
  {
    key: 'first_name',
    name: 'First name',
    minWidth: 90,
    maxWidth: 140,
    isMultiline: true,
    onRender: (subscriber: QuarterSubscriber) => orPlaceholder(subscriber.first_name),
  },
  {
    key: 'last_name',
    name: 'Last name',
    minWidth: 90,
    maxWidth: 140,
    isMultiline: true,
    onRender: (subscriber: QuarterSubscriber) => orPlaceholder(subscriber.last_name),
  },
  {
    key: 'email',
    name: 'Email',
    minWidth: 160,
    maxWidth: 260,
    isMultiline: true,
    onRender: (subscriber: QuarterSubscriber) => orPlaceholder(subscriber.email),
  },
  {
    key: 'plans',
    name: 'Plan',
    minWidth: 140,
    isMultiline: true,
    onRender: (subscriber: QuarterSubscriber) =>
      subscriber.plans.length > 0 ? subscriber.plans.join(', ') : PLACEHOLDER,
  },
]

const SubscribersTable = ({ subscribers, ariaLabel, emptyMessage }: SubscribersTableProps) => {
  if (subscribers.length === 0) {
    return <Text styles={{ root: { ...MUTED_TEXT.root, padding: '8px 0', display: 'block' } }}>{emptyMessage}</Text>
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <DetailsList
        items={subscribers}
        columns={columns}
        getKey={(subscriber: QuarterSubscriber) => subscriber.user_id}
        selectionMode={SelectionMode.none}
        layoutMode={DetailsListLayoutMode.justified}
        compact
        ariaLabelForGrid={ariaLabel}
        onShouldVirtualize={() => false}
      />
    </div>
  )
}

export default SubscribersTable
